import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { DataAnalyticsService } from '../../../data-analytics/data-analytics.service';
import { TimeSeriesData } from '../../../interfaces/time-series-data';
import { LwEnergyMonitorGraph } from '../../lw-graphs/energy-monitor-graph';
import { LwHeatingGraph } from '../../lw-graphs/heating-graph';
import { LwHeatingExternalGraph } from '../../lw-graphs/heating-graph-external';
import { forkJoin } from 'rxjs';
import { selectAll } from 'd3';
import { DemoAccountService } from '../../../demo-account.service';
import { GlobalVariablesService, time } from '../../../services/global-variables.service'
import { LdsUserService } from '../../../services/lds-user.service';
import { LdsEventBusService } from '../../../services/lds-event-bus.service';
import { LwSwitchMainGraph } from '../../lw-graphs/switch-main';
import { MotionGraph } from '../../lw-graphs/motion-graph';
import { OctopusService } from '../../../services/octopus-service.service';
import { DateTime } from 'luxon';
import { ChartJsEnergyGraph } from '../../lw-graphs/chart-js-energy';
import { ChartJsHeating } from '../../lw-graphs/chart-js-heating';
import { ChartJsMotion } from '../../lw-graphs/chart-js-motion';
import { ActiveGraphService } from '../../active-graph.service';
import { Chart } from 'chart.js';

@Component({
    selector: 'lds-y3-graph',
    templateUrl: './y3-graph.component.html',
    styleUrls: ['./y3-graph.component.css'],
    standalone: false
})
export class Y3GraphComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  constructor(private activeGraphs: ActiveGraphService, private dataAnalyticsService: DataAnalyticsService, private demo: DemoAccountService, private globalVars: GlobalVariablesService, private user: LdsUserService, private eventBus: LdsEventBusService, private octopus: OctopusService) { }
  @Input() deviceType: string;
  @Input() data: any;
  @Input() features: any;
  @Input() timespan: string;
  @Input() isOctopus: boolean;
  @Input() productCode: string;
  @ViewChild('graph', { static: false }) graphArea: ElementRef;
  @ViewChild('miniGraph', { static: false }) miniGraphArea: ElementRef;
  @ViewChild('octopusGraph', { static: false }) octopusGraphArea: ElementRef;
  graph: any;
  miniGraph: any;
  loading2 = true;
  loading1 = true;
  loadingOctopus = true;
  viewInit = false;
  secondGraphShow = true;
  @Input() startTime;
  @Input() endTime;

  public heightStyleMain = "lds-container SD-graph-main h250 mt-2";
  public heightStyleMini = "lds-container h200 mt-2 SD-graph-main";

  ngOnInit() {

  }

  ngOnDestroy() {
    if (this.graph) {
      this.graph.destroy();
    }
    if (this.miniGraph) {
      this.miniGraph.destroy();
    }
  }

  private compareFunc(a, b) {
    if (a.timestamp < b.timestamp) {
      return -1;
    }
    if (a.timestamp > b.timestamp) {
      return 1;
    }
    return 0;
  }

  private async addPowerGraph() {
    this.loading2 = true;
    const startTime = this.startTime;
    const endTime = this.endTime;
    for (let i = 0; i < this.features.length; i++) {
      let feature = this.features[i];
      if (feature.attributes.type === 'power') {
        let device;
        // if (this.productCode && this.productCode === 'LW600') {
        //   device = this.user.energyMonitors[this.features[0].deviceId];
        // } else {
        device = this.user.energyFeatureSets[feature.groupId];
        // }

        if (this.timespan !== "custom") {
          this.dataAnalyticsService.getFeatureRawDateRange(feature.featureId, this.timespan).subscribe((res: any) => {
            this.eventBus.broadcast("energy-monitor-data-loaded", res);
          });
        } else {
          this.dataAnalyticsService.getPagedRawData(null, feature.featureId, 50000, startTime, endTime);
        }
      }
    }
  }
  // Currently not in use but may be needed for future
  private addOctopusPowerGraph() {
    switch (this.timespan) {
      case 'weekly':
        this.octopus.getOctopusPowerData(this.timespan).subscribe((res: any) => {

          const data = res.results.map(results => {
            const dt = DateTime.fromISO(results.interval_start);
            const timestamp = dt.toMillis(dt);
            const value = parseInt(results.consumption.toFixed(2));
            return {
              timestamp,
              value
            }
          });
          this.loading2 = false;
        })
        break;
      case 'monthly':
        this.octopus.getOctopusPowerData(this.timespan).subscribe((res: any) => {

          const data = res.results.map(results => {
            const dt = DateTime.fromISO(results.interval_start);
            const timestamp = dt.toMillis(dt);
            const value = parseInt(results.consumption.toFixed(2));
            return {
              timestamp,
              value
            }
          });
          this.loading2 = false;
        })
        break;
    }
  }

  private async getHeatingData() {
    let observables = [];
    for (let i = 0; i < this.features.length; i++) {
      if (!this.features[i]) {
        continue;
      }

      if (this.timespan !== "custom") {
        observables.push(
          this.dataAnalyticsService.getFeatureRawDateRange(this.features[i].featureId, this.timespan)
        );
      }
      else {
        observables.push(
          this.dataAnalyticsService.getFeatureRawDateRange(this.features[i].featureId, this.dataAnalyticsService.getDaysBetween(this.startTime, this.endTime), this.startTime, this.endTime, "temperature")
        );
      }
    }

    return new Promise<any>((resolve) => {
      forkJoin(observables).subscribe(res => {
        resolve(res);
      });
    });
  }

  private getHeatingDataForLW921E(range = 'weekly') {
    let observables = [];

    for (let i = 0; i < this.features.length; i++) {
      observables.push(
        this.dataAnalyticsService.getFeatureRawDateRange(this.features[i].featureId, range)
      );
    }

    forkJoin(observables).subscribe(
      response => {
        this.graph.draw(response, this.features);
        this.loading1 = false;
        this.loading2 = false;
      },
      err => {
        console.log(err);
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.graph) {
      this.graph.destroy();
    }

    if (this.miniGraph) {
      this.miniGraph.destroy();
    }
    selectAll('.SD-graph-main > .SD-graph > svg').remove();

    this.loading1 = true;
    this.loading2 = true;
    // if(this.deviceType === "energy" && this.timespan === "custom" && !changes.data){
    //   this.loading1 = true;
    //   this.loading2 = true;
    //   this.activeGraphs.destroyGraphs();
    //   return;
    // }

    // this.activeGraphs.destroyGraphs();
    // this.loading1 = true;
    // if (this.secondGraphShow) {
    //   this.loading2 = true;
    // }

    this.setGraph();

  }

  async setGraph() {

    const chartExists = Chart.getChart("graph1");
    if (chartExists) {
      chartExists.destroy();
    }

    const miniGraphExists = Chart.getChart("miniGraph");
    if (miniGraphExists) {
      miniGraphExists.destroy();
    }

    switch (this.deviceType) {
      case 'thermoE':
        this.graph = new LwHeatingExternalGraph(
          this.graphArea.nativeElement,
          null
        );
        this.getHeatingDataForLW921E();
        this.secondGraphShow = false;
        break;
      case 'thermo':
        this.secondGraphShow = false;
        this.loading2 = false;
        let thermoGraph = new ChartJsHeating();
        let thermoData = await this.getHeatingData();
        thermoGraph.draw(thermoData, this.features);
        this.graph = thermoGraph.graph;
        this.activeGraphs.graph = this.graph;
        break;
      case 'temperature':
      case 'TRV':
        this.secondGraphShow = false;
        let heatingGraph = new ChartJsHeating();
        let data = await this.getHeatingData();
        heatingGraph.draw(data, this.features);
        this.graph = heatingGraph.graph;
        this.activeGraphs.graph = this.graph;
        this.loading1
        break;
      case 'LW600':
      case 'energy':
        this.secondGraphShow = true;
        const graph = new ChartJsEnergyGraph(this.data, this.globalVars);
        graph.drawGraph();
        this.graph = graph.graph;
        this.addPowerGraph();
        this.activeGraphs.graph = this.graph;
        this.eventBus.startSubscribe("energy-monitor-data-loaded", (res) => {
          this.loading2 = false;
          graph.addPowerGraph(res);

          this.miniGraph = graph.miniGraph;
          this.activeGraphs.miniGraph = this.miniGraph;
          this.eventBus.clearEvent("energy-monitor-data-loaded");
          return;
        });

        this.loading1 = false;
        if (this.isOctopus) {
          this.secondGraphShow = false;
          break;
        }
        break;
      case "motion":
        this.loading1 = true;
        this.secondGraphShow = false;
        this.loading2 = false;
        this.heightStyleMain = "lds-container SD-graph-main h250-extended mt-2"
        this.heightStyleMini = "lds-container h200-extended mt-2 SD-graph-main"
        const motionGraph = new ChartJsMotion();

        const motionData = await this.getHeatingData();

        motionGraph.draw(motionData, this.features);
        this.graph = motionGraph.graph;
        this.activeGraphs.graph = this.graph;
        break;
      // case 'octopus':
      //   this.graph = new LwEnergyMonitorGraph(this.graphArea.nativeElement, this.globalVars);
      //   this.loading1 = false;
      //   this.graph.draw(this.data);
      //   this.addOctopusPowerGraph();
      default:
    }
  }



  ngAfterViewInit() {
    this.viewInit = true;
    // this.setGraph(); // doesnt seem to be needed
  }

  resetGraph() {
    if (this.graph) {
      this.graph.resetZoom();
    }
    if (this.miniGraph) {
      this.miniGraph.resetZoom();
    }
  }

}
